import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCentosComponent } from './simple-icons-centos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCentosComponent ],
    exports:      [ SimpleIconsCentosComponent ],
    bootstrap:    []
})
export class SimpleIconsCentosModule {}
